var jade = require("/home/circleci/rentapplication-frontend/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<form name=\"resetPasswordForm\"><h3>Current Password</h3><input type=\"password\" ng-model=\"currentPassword\" id=\"currentPassword\" required><h3>New Password</h3><div class=\"field\"><input type=\"password\" ng-model=\"password\" id=\"newPassword\" required class=\"password-input\"><h3>Confirm New Password</h3><input type=\"password\" ng-model=\"newPasswordConfirm\" id=\"newPasswordConfirm\" required class=\"password-input\"><password-guide></password-guide></div><input type=\"submit\" value=\"Update Password\" ng-click=\"changePassword()\" ng-class=\"{'check-disabled': resettingPassword}\" class=\"submit-button1\"></form>");;return buf.join("");
}


//////////////////
// WEBPACK FOOTER
// ./directives/passwordChangeForm/passwordChangeForm.jade
// module id = 425
// module chunks = 0